export const smashData = [
    //CLASSIC
    {
        id: 100,
        category: "burger",
        type: "classic",
        name: "Classic Idzuo smash",
        subtitle: "",
        desc: "2x 70г 100% јунеће месо, 2x чедар сир, црвени сос, сенф, црвени лук, кисели краставац",
        grams: "",
        price: "520",
        image: "https://idzuo.com/menuImages/smash/smash-classic.webp",
        cart: "Додајте у корпу",
    },
    {
        id: 101,
        category: "burger",
        type: "classic",
        name: "Classic Triple smash",
        subtitle: "",
        desc: "3x 70г 100% јунеће месо, 2x чедар сир, црвени сос, сенф, црвени лук, кисели краставац",
        grams: "",
        price: "590",
        image: "https://idzuo.com/menuImages/smash/smash-classic.webp",
        cart: "Додајте у корпу",
    },
    {
        id: 102,
        category: "burger",
        type: "classic",
        name: "Classic Double - Double smash",
        subtitle: "",
        desc: "4x 70г 100% јунеће месо, 2x чедар сир, црвени сос, сенф, црвени лук, кисели краставац",
        grams: "",
        price: "660",
        image: "https://idzuo.com/menuImages/smash/smash-classic.webp",
        cart: "Додајте у корпу",
    },
    {
        id: 103,
        category: "burger",
        type: "classic",
        name: "Classic Triple - Double smash",
        subtitle: "",
        desc: "5x 70г 100% јунеће месо, 5x чедар сир, црвени сос, сенф, црвени лук, кисели краставац",
        grams: "",
        price: "730",
        image: "https://idzuo.com/menuImages/smash/smash-classic.webp",
        cart: "Додајте у корпу",
    },

    //ORIGINAL
    {
        id: 110,
        category: "burger",
        type: "original",
        name: "Original Idzuo",
        subtitle: "",
        desc: "2x 70г 100% јунеће месо, 2x чедар сир, бургер сос, миx 9 салата, црвени лук, кисели краставац",
        grams: "",
        price: "520",
        image: "https://idzuo.com/menuImages/smash/smash-original.webp",
        cart: "Додајте у корпу",
    },
    {
        id: 111,
        category: "burger",
        type: "original",
        name: "Original Triple",
        subtitle: "",
        desc: "3x 70г 100% јунеће месо, 2x чедар сир, бургер сос, миx 9 салата, црвени лук, кисели краставац",
        grams: "",
        price: "590",
        image: "https://idzuo.com/menuImages/smash/smash-original.webp",
        cart: "Додајте у корпу",
    },
    {
        id: 112,
        category: "burger",
        type: "original",
        name: "Original Double - Double",
        subtitle: "",
        desc: "4x 70г 100% јунеће месо, 2x чедар сир, бургер сос, миx 9 салата, црвени лук, кисели краставац",
        grams: "",
        price: "660",
        image: "https://idzuo.com/menuImages/smash/smash-original.webp",
        cart: "Додајте у корпу",
    },
    {
        id: 113,
        category: "burger",
        type: "original",
        name: "Original Triple - Double",
        subtitle: "",
        desc: "5x 70г 100% јунеће месо, 5x чедар сир, бургер сос, миx 9 салата, црвени лук, кисели краставац",
        grams: "",
        price: "730",
        image: "https://idzuo.com/menuImages/smash/smash-original.webp",
        cart: "Додајте у корпу",
    },


    //JALAPENO
    {
        id: 120,
        category: "burger",
        type: "jalapeno",
        name: "Bbq jalapeño",
        subtitle: "",
        desc: "2x 70г 100% јунеће месо, 2x чедар сир, bbq сос, онион рингс, јапалењо паприка",
        grams: "",
        price: "520",
        image: "https://idzuo.com/menuImages/smash/smash-jalapeno.webp",
        cart: "Додајте у корпу",
    },
    {
        id: 121,
        category: "burger",
        type: "jalapeno",
        name: "Bbq jalapeño - Triple",
        subtitle: "",
        desc: "3x 70г 100% јунеће месо, 2x чедар сир, bbq сос, онион рингс, јапалењо паприка",
        grams: "",
        price: "590",
        image: "https://idzuo.com/menuImages/smash/smash-jalapeno.webp",
        cart: "Додајте у корпу",
    },
    {
        id: 122,
        category: "burger",
        type: "jalapeno",
        name: "Bbq jalapeño - Double - Double",
        subtitle: "",
        desc: "4x 70г 100% јунеће месо, 2x чедар сир, bbq сос, онион рингс, јапалењо паприка",
        grams: "",
        price: "660",
        image: "https://idzuo.com/menuImages/smash/smash-jalapeno.webp",
        cart: "Додајте у корпу",
    },
    {
        id: 123,
        category: "burger",
        type: "jalapeno",
        name: "Bbq jalapeño - Triple - Double",
        subtitle: "",
        desc: "5x 70г 100% јунеће месо, 5x чедар сир, bbq сос, онион рингс, јапалењо паприка",
        grams: "",
        price: "730",
        image: "https://idzuo.com/menuImages/smash/smash-jalapeno.webp",
        cart: "Додајте у корпу",
    },


    //BLUE CHEESE
    {
        id: 130,
        category: "burger",
        type: "bluecheese",
        name: "Blue Cheese and Bacon",
        subtitle: "",
        desc: "2x 70г 100% јунеће месо, bbq сос, чедар сир, горгонзола, хрскави лук, панчета",
        grams: "",
        price: "520",
        image: "https://idzuo.com/menuImages/smash/smash-blue-cheese.webp",
        cart: "Додајте у корпу",
    },
    {
        id: 131,
        category: "burger",
        type: "bluecheese",
        name: "Blue Cheese and Bacon Triple",
        subtitle: "",
        desc: "3x 70г 100% јунеће месо, bbq сос, чедар сир, горгонзола, хрскави лук, панчета",
        grams: "",
        price: "590",
        image: "https://idzuo.com/menuImages/smash/smash-blue-cheese.webp",
        cart: "Додајте у корпу",
    },
    {
        id: 132,
        category: "burger",
        type: "bluecheese",
        name: "Blue Cheese and Bacon Double - Double Smash",
        subtitle: "",
        desc: "4x 70г 100% јунеће месо, bbq сос, чедар сир, горгонзола, хрскави лук, панчета",
        grams: "",
        price: "660",
        image: "https://idzuo.com/menuImages/smash/smash-blue-cheese.webp",
        cart: "Додајте у корпу",
    },
    {
        id: 133,
        category: "burger",
        type: "bluecheese",
        name: "Blue Cheese and Bacon Triple - Double",
        subtitle: "",
        desc: "5x 70г 100% јунеће месо, bbq сос, чедар сир, горгонзола, хрскави лук, панчета",
        grams: "",
        price: "730",
        image: "https://idzuo.com/menuImages/smash/smash-blue-cheese.webp",
        cart: "Додајте у корпу",
    },

   
    //ONION JAM
    {
        id: 140,
        category: "burger",
        type: "onionjam",
        name: "Onion Jam",
        subtitle: "",
        desc: "2x 70г 100% јунеће месо, 2× чедар сир, бургер сос, кисели краставац, џем од лука и панчете",
        grams: "",
        price: "520",
        image: "https://idzuo.com/menuImages/smash/smash-onion-jam.webp",
        cart: "Додајте у корпу",
    },
    {
        id: 141,
        category: "burger",
        type: "onionjam",
        name: "Onion Jam Triple",
        subtitle: "",
        desc: "3x 70г 100% јунеће месо, 2× чедар сир, бургер сос, кисели краставац, џем од лука и панчете",
        grams: "",
        price: "590",
        image: "https://idzuo.com/menuImages/smash/smash-onion-jam.webp",
        cart: "Додајте у корпу",
    },
    {
        id: 142,
        category: "burger",
        type: "onionjam",
        name: "Onion Jam Double - Double",
        subtitle: "",
        desc: "4x 70г 100% јунеће месо, 2× чедар сир, бургер сос, кисели краставац, џем од лука и панчете",
        grams: "",
        price: "660",
        image: "https://idzuo.com/menuImages/smash/smash-onion-jam.webp",
        cart: "Додајте у корпу",
    },
    {
        id: 143,
        category: "burger",
        type: "onionjam",
        name: "Onion Jam Triple - Double",
        subtitle: "",
        desc: "5x 70г 100% јунеће месо, 2× чедар сир, бургер сос, кисели краставац, џем од лука и панчете",
        grams: "",
        price: "730",
        image: "https://idzuo.com/menuImages/smash/smash-onion-jam.webp",
        cart: "Додајте у корпу",
    },


    //SMASH DRINKS
    {
        id: 150,
        category: "smashdrinks",
        type: "",
        name: "Кока кола 0,33",
        subtitle: "",
        desc: "",
        grams: "",
        price: "130",
        image: "https://idzuo.com/menuImages/drinks/coca_cola_0.33l.webp",
        cart: "Додајте у корпу",
      },
      {
        id: 151,
        category: "smashdrinks",
        type: "",
        name: "Кока кола зеро",
        subtitle: "",
        desc: "",
        grams: "",
        price: "130",
        image: "https://idzuo.com/menuImages/drinks/coca_cola_zero_limenka_0.33l.webp",
        cart: "Додајте у корпу",
      },

    //SMASH SIDES
    {
        id: 152,
        category: "smashsides",
        type: "",
        name: "Помфрит 200г",
        subtitle: "",
        desc: "",
        grams: "",
        price: "200",
        image: "https://idzuo.com/menuImages/smash/pomfrit-50g.webp",
        cart: "Додајте у корпу",
    },
    {
        id: 153,
        category: "smashsides",
        type: "",
        name: "Онион рингс 250г",
        subtitle: "",
        desc: "",
        grams: "",
        price: "290",
        image: "https://idzuo.com/menuImages/smash/onion-rings.webp",
        cart: "Додајте у корпу",
    },

];
  
  